<ul class="w-100 list-group rounded-0">
    <app-hide-by-permission-wrapper [forPermission]="getCorrectPersmission()">
        <li class="list-group-item d-block py-1">
            <div class="row w-100 d-flex align-items-center">
                <div class="col-9 text-truncate float-none form-check form-switch">
                    <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch"
                        [id]="plugin.code" (change)="toggleShowPlugins($event)" [checked]="plugin.enabled"
                        [disabledByPermission]="getCorrectPersmission()">
                    <label class="col-10" for="plugin.enabled" translate>Sources.{{plugin.code}}<app-info-button
                            labelName="Settings.IntegrationsImportExportSection.{{plugin.code}}Tooltip" [url]="PlatformApiUrl"
                            placement="bottom"></app-info-button></label>
                </div>
                <div class="col-3 text-end">
                    <div class="btn-group">
                        <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li>
                                <a class="dropdown-item pt-1 pb-1" (click)="dialog()" translate="Button.Edit"></a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </li>
    </app-hide-by-permission-wrapper>
</ul>